"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnGroupToggle = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../Icons/PetSure/Icon");
var _TableProps = require("../TableProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ColumnGroupToggle = _ref => {
  let {
    column
  } = _ref;
  // This feature triggers the aggregation capability
  if (!column.canGroupBy) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    className: "button icon_only tableGroupControl ".concat(column.isGrouped ? 'tableGroupControl_grouped' : ''),
    type: "button"
  }, column.getGroupByToggleProps()), column.isGrouped ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Ungroup columns"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "api-connect"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Group and aggregate columns"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "api-connect"
  })));
};
exports.ColumnGroupToggle = ColumnGroupToggle;
ColumnGroupToggle.propTypes = {
  column: _propTypes.default.shape(_TableProps.ColumnGroupProps)
};